<template>
	<div class="mt-2">
		<div class="vx-row">
			<div class="vx-col md:w-2/5 sm:3/3 w-full">
				<vx-card :title="$t('Routing.Title.MatchColumn')" no-shadow card-border class="mb-2">
					<p>{{ $t("Routing.Messages.MatchColumnSelectionRoutingP2") }}</p>
					<vs-divider />
					<vue-perfect-scrollbar class="scroll-area" :settings="settings" @ps-scroll-y="scrollHandle">
						<vx-input-group class="mb-2" :key="key" v-for="key in required_keys">
							<template slot="prepend">
								<div class="prepend-text bg-primary">
									<span>{{ resolvePoliticalDivisionName(key) | capitalize }}</span>
								</div>
							</template>
							<v-select
								class="select-large"
								v-model="equivalent_fields[key]"
								:clearable="true"
								:options="equivalentFieldsFefault"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:value="v_select_selected"
								@input="setSelected"
								:multiple="isSelectMultiple(key)"
								:title="
									isSelectMultiple(key)
										? $t('Object.statusOptions.MultipleChoice')
										: $t('Object.statusOptions.Select')
								"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("general.NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
								</template>
							</v-select>
						</vx-input-group>
					</vue-perfect-scrollbar>
				</vx-card>
			</div>
			<div class="vx-col md:w-3/5 sm:3/3 w-full">
				<vx-card :title="$t('Routing.Title.TableExample')" no-shadow card-border class="mb-2">
					<p>{{ $t("Routing.Title.TableExampleText") }}</p>
					<vs-divider />
					<vue-perfect-scrollbar class="scroll-area-table" :settings="settings" @ps-scroll-y="scrollHandle">
						<table class="table-equi" style="width: 180vh">
							<thead>
								<tr class="th-colum">
									<th :key="header" v-for="header in headers">
										{{ header | mayus }}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr :data="tr" :key="index" v-for="(tr, index) in uploadRecords">
									<td :key="header" v-for="header in headers">
										<p class="product-name font-medium truncate">
											{{ tr[header] }}
										</p>
									</td>
								</tr>
							</tbody>
						</table>
					</vue-perfect-scrollbar>
				</vx-card>
			</div>
			<vs-popup :title="popupTitle" :active.sync="popupActiveAlert">
				<alert size="small" :title="alert_title" :message="alert_message" :color="alert_color"></alert>
			</vs-popup>
		</div>
		<div class="vx-row">
			<div class="vx-col w-full">
				<div class="mb-base flex flex-wrap items-center justify-end">
					<vs-button
						class="mr-2"
						type="border"
						color="danger"
						icon-pack="feather"
						icon="icon-x"
						@click="$emit('cancelEquivalenceEmit')"
						>{{ $t("Cancel") }}
					</vs-button>
					<vs-button icon-pack="feather" icon="icon-save" @click="validateUploadEquivalents"
						>{{ $t("Save") }}
					</vs-button>
				</div>
			</div>
		</div>

		<vs-popup :title="$t('Routing.Title.MatchColumn')" :active.sync="equivalentDataErrorsAlert">
			<vs-alert icon="warning" :active="equivalentDataErrorsAlert" color="danger" class="my-3">
				<span>{{ $t("ManualData.ErrorsFound") }}.</span>
			</vs-alert>

			<vue-perfect-scrollbar class="scroll-area-table" :settings="settings">
				<vs-table :data="equivalentDataErrors">
					<template slot="thead">
						<vs-th>{{ $t("Register") }} N</vs-th>
						<vs-th>{{ $t("Error") }}</vs-th>
					</template>

					<template slot-scope="{data}">
						<vs-tr :key="indextr" v-for="(tr, indextr) in data">
							<vs-td :data="data[indextr].index">
								{{ data[indextr].index + 1 }}
							</vs-td>
							<vs-td :data="data[indextr].index">
								<span>{{ $t("ManualData.PropertyError") }} </span>
								<span class="font-semibold"
									>{{ identifyPropertyName(data[indextr].message) | title }},
								</span>
								<span> {{ identifyMessageError(data[indextr].message) }}</span>
							</vs-td>
						</vs-tr>
					</template>
				</vs-table>
			</vue-perfect-scrollbar>
		</vs-popup>
	</div>
</template>

<script>
import vSelect from "vue-select";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Commons from "@/helpers/commons.js";
import Alert from "@/components/alerts/Alert.vue";

export default {
	components: {
		vSelect,
		Alert,
		VuePerfectScrollbar,
	},
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					actionDropdown: true,
					btnAssigGroup: false,
					columns: ["name", "description", "address", "hour_init", "hour_end", "action"],
				};
			},
		},
	},
	data() {
		return {
			selected: [],
			itemsPerPage: 5,
			isMounted: false,
			addNewDataSidebar: false,
			sidebarData: {},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			currentPageLocal: 1,
			quantityElementPage: 10,
			groupDelete: null,
			equivalentOptions: [
				"cx",
				"cy",
				"identification",
				"demand",
				"end_hour_window",
				"init_hour_window",
				"skills",
				"time_service",
				"add",
				"null",
			],
			equivalent_fields_default_selected: [],
			equivalent_fields: {},
			equivalent_fields_result: null,
			v_select_selected: "add",
			popupActiveAlert: false,
			alert_title: "",
			alert_message: "",
			alert_color: "",
			popupTitle: "",
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			equivalentDataErrors: [],
			equivalentDataErrorsAlert: false,
		};
	},
	computed: {
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		uploadRecords() {
			return this.$store.state.uploadFile.currentUpload.records;
		},
		headers() {
			return this.$store.state.uploadFile.currentUpload.keys;
		},
		required_keys() {
			const requiredKeys = Object.keys(this.$store.state.uploadFile.currentUpload.required_keys).map((el) => {
				return el;
			});
			return requiredKeys;
		},
		resolvePoliticalDivisionName() {
			return (el) => {
				if (el === "department") return "dpto / state / prov / region";
				if (el === "city") return "city / mun / comu / cton / dsto";
				return el;
			};
		},

		isSelectMultiple() {
			return function (key) {
				return Array.isArray(this.$store.state.uploadFile.currentUpload.required_keys[key]);
			};
		},
		equivalent_options() {
			return this.$store.state.uploadFile.currentUpload.keys.map((el) => {
				return el;
			});
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.uploadRecords.length;
		},
		equivalentFieldsFefault: {
			get() {
				return this.equivalent_options.filter(
					(e) => !this.equivalent_fields_default_selected.some((eq) => eq === e)
				);
			},
			set(val) {},
		},
		identifyPropertyName() {
			return function (message) {
				return message.split(" ")[0];
			};
		},
		identifyMessageError() {
			return function (message) {
				return this.findText("has an invalid value", message) ? this.$t("ManualData.InvalidValue") : message;
			};
		},
	},
	methods: {
		scrollHandle(evt) {},
		setSelected(value) {
			this.setEquivalents();
		},
		setEquivalents() {
			let equivalentFields = {};
			for (const property in this.equivalent_fields) {
				const value = this.equivalent_fields[property];
				if (value !== "null") {
					if (value === "add") {
						equivalentFields[property] = property;
					} else {
						equivalentFields[property] = value;
					}
				}
			}
			this.equivalent_fields_result = {...equivalentFields};
			this.equivalent_fields_default_selected = Object.values(equivalentFields);

			this.$store.commit("uploadFile/SET_EQUIVALENTS", this.equivalent_fields_result);
		},
		updateEquivalentsOptions(equivalent_fields_default_selected) {
			const index = this.equivalent_fields_default.findIndex((val) => val === key);
			this.equivalent_fields_default.splice(index, 1);
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		enableHeadTable(headName) {
			return this.customConfig.columns.includes(headName);
		},
		getChecked() {},
		addNewData() {
			this.sidebarData = {};
			this.toggleDataSidebar(true);
		},
		confirmDeleteAlarm(data) {
			this.alarmDelete = data;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: "Confirm Delete",
				text: this.$t("Alarm.DeleteYouAre") + ` "${this.alarmDelete.name}"`,
				accept: this.deleteAlarm,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAlarm() {
			this.openLoading();
			this.$store
				.dispatch("moduleAlarm/removeZoneAlarm", this.alarmDelete.key)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("Alarm.TitleConfirmAlarmDelete"),
						text: this.$t("Alarm.TextConfirmAlarmDelete"),
					});
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					this.closeLoading();
				});
		},
		editData(data) {
			this.$emit("selectedAlarmEmit", data);
		},
		toggleDataSidebar(val = false) {
			this.addNewDataSidebar = val;
		},
		cahngeCurrentPageLocal() {
			this.currentPageLocal = 1;
		},
		validateUploadEquivalents() {
			if (!this.validateRequiredKeys()) {
				this.alert_title = this.$t("Routing.Messages.MatchColumnSelectionRoutingErrorTitle");
				this.alert_message = `${this.$t(
					"Routing.Messages.MatchColumnSelectionRoutingError"
				)} ${this.missingRequiredKeys().join(", ")}`;
				this.alert_color = "warning";
				this.popupTitle = this.$t("Routing.Buttons.Validate");
				this.popupActiveAlert = true;
				return;
			}

			let equivalents = {
				required_keys: this.$store.state.uploadFile.equivalents || {},
				role_id: this.$store.state.uploadFile.currentUpload.role_id,
				country: this.$store.state.uploadFile.currentUpload.country,
			};

			if (!equivalents.role_id) delete equivalents.role_id;
			if (!equivalents.country) delete equivalents.country;

			let payload = {
				id: this.$store.state.uploadFile.currentUpload.id,
				body: equivalents,
			};

			this.openLoading();
			this.$store
				.dispatch("uploadFile/uploadValidate", payload)
				.then((res) => {
					this.$emit("closeEquivalenceEmit");
					this.closeLoading();
				})
				.catch((error) => {
					this.closeLoading();
					if (error) {
						if (Array.isArray(error.data)) {
							this.manageArrayErrors(error.data);
						} else {
							this.manageErrorAlert(error);
						}
					} else {
						if (error.message === "missing fields: ['equivalent_fields']") {
							this.alert_title = this.$t("Routing.Messages.MatchColumnSelectionRoutingErrorTitle");
							this.alert_message = `${this.$t(
								"Routing.Messages.MatchColumnSelectionRoutingErrorEquivalents"
							)}`;
							this.alert_color = "danger";
							this.popupTitle = this.$t("Error");
							this.popupActiveAlert = true;
						}
					}
				});
		},
		manageErrorAlert(err) {
			const {title, text} = Commons.manageErrorValidator.call(this, err);
			const findErrorNameProperty = Commons.findErrorNameProperty();
			const nameProperty = findErrorNameProperty(err);

			this.alert_title = this.$t("Routing.Messages.MatchColumnSelectionRoutingErrorTitle");
			this.alert_message = `${this.$t(
				"Routing.Messages.MatchColumnSelectionRoutingError"
			)} ${nameProperty.toUpperCase()}`;
			this.alert_color = "danger";
			this.popupTitle = this.$t("Error");
			this.popupActiveAlert = true;
		},
		validateRequiredKeys() {
			const assignedRequiredKeys = this.$store.state.uploadFile.equivalents || {};
			const {required_keys, upload_type} = this.$store.getters["uploadFile/uploadedInfo"];

			const keys1 = Object.keys(required_keys);
			const keys2 = Object.keys(assignedRequiredKeys);

			if (upload_type === "LAYER") {
				return Object.hasOwnProperty.call(assignedRequiredKeys, "name") && assignedRequiredKeys.name;
			}
			const haveSameProperties =
				keys1.length === keys2.length && keys1.every((key) => keys2.includes(key) && assignedRequiredKeys[key]);
			return haveSameProperties;
		},
		missingRequiredKeys() {
			const assignedRequiredKeys = this.$store.state.uploadFile.equivalents || {};
			const {required_keys, upload_type} = this.$store.getters["uploadFile/uploadedInfo"];
			const keys1 = Object.keys(required_keys);

			if (upload_type === "LAYER" && !Object.hasOwnProperty.call(assignedRequiredKeys, "name")) {
				return ["name"];
			}

			return keys1.filter((key) => !assignedRequiredKeys[key]);
		},
		manageArrayErrors(data = []) {
			this.equivalentDataErrors = data;
			this.equivalentDataErrorsAlert = true;
		},
		findText(searchStr, str) {
			return str.search(searchStr) !== -1 ? true : false;
		},

		/**
		 * Automatically assigns equivalent fields based on the keys present in the current upload.
		 * @method autoEquivalents
		 * @returns {void}
		 */
		autoEquivalents() {
			const keys = [...this.$store.state.uploadFile.currentUpload.keys];
			// check if keys are in the object and assign them to the equivalent_fields
			for (const key of this.required_keys) {
				if (keys.includes(key)) {
					this.equivalent_fields[key] = key;
				}
			}
		},
	},
	filters: {
		mayus(val = "") {
			return val.toUpperCase();
		},
	},
	watch: {
		itemsPerPage(val) {
			this.currentPageLocal = 1;
		},
	},
	created() {
		this.equivalent_fields = {...this.$store.state.uploadFile.equivalents};
		/**
		 * Checks if there are equivalent fields and sets the equivalents accordingly.
		 * If there are no equivalent fields, it sets the required keys as empty strings,
		 * auto-generates the equivalents, and then sets the equivalents.
		 */
		if (Object.values(this.equivalent_fields).length > 0) {
			this.setEquivalents();
		} else {
			const required_keys = {...this.$store.state.uploadFile.currentUpload.required_keys};
			for (const key in required_keys) {
				this.equivalent_fields[key] = "";
			}
			this.autoEquivalents();
			this.setEquivalents();
		}
	},
	mounted() {
		this.isMounted = true;
	},
};
</script>

<style lang="scss" scoped>
th {
	border: 1px solid #dddddd;
	text-align: left;
	padding: 8px;
}

td {
	border-bottom: 1px solid #dddddd;
	text-align: left;
	padding: 8px;
}

.th-equi {
	background: #dce5dd !important;
}

.th-colum {
	background: #352d93 !important;
	color: white;
}

.scroll-area {
	margin: auto;
	width: 100%;
	height: 450px;
}

.scroll-area-table {
	margin: auto;
	width: 100%;
	height: 450px;
}
</style>
